import React, { useContext, useState } from "react";
import { Modal, Button, Form, Toast } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { ConfigContext } from "../context/GlobalContext";
import { toast } from "react-toastify";
import { DeleteExpense } from "../data";
import { Languages } from "../Utils/Languages";
import AddDeletedUserDataInFirebase from "../data/Firebase/User/AddDeletedUserDataInFirebase";
import { set } from "firebase/database";
import { auth } from "../Utils/firebase";
import * as actionType from '../context/actions';
import { EmailAuthProvider, GoogleAuthProvider, reauthenticateWithCredential, signInWithPopup, signOut } from 'firebase/auth';
import { DeleteAccountMailAPI } from "../MailAPIs/DeleteAccountMailAPI";

const DeleteAccountView = ({ show, setShow }) => {
    const { state, dispatch } = useContext(ConfigContext);
    const [deleteReason, setDeleteReason] = useState("");
    const navigate = useNavigate();
    const handleClose = () => {
        setShow(false);
        setDeleteReason("");
    };
    const firebaseId = state?.SET_USER?.user_uid;

    
    
    const handleDelete = async () => {
        AddDeletedUserDataInFirebase(state, dispatch, firebaseId, state?.SET_USER, deleteReason);
        setShow(false);
        localStorage.removeItem("AccessUserId");
        localStorage.removeItem("appState");
        dispatch({ type: actionType.EMPTY_ALL_STATE });
        navigate("/login");
        // DeleteAccountMailAPI(state?.SET_USER?.email, state?.SET_USER?.name);

    };


    

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    {Languages[state?.LANGUAGE]?.Confirm_Deletion || "Confirm Deletion"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group controlId="deleteReason">
                    <Form.Label>{Languages[state?.LANGUAGE]?.Reason || "Reason"}:</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder={Languages[state?.LANGUAGE]?.Enter_Reason || "Enter reason"}
                        value={deleteReason}
                        onChange={(e) => setDeleteReason(e.target.value)}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {Languages[state?.LANGUAGE]?.Cancel || "Cancel"}
                </Button>
                <Button
                    variant="danger"
                    className="bg-danger"
                    onClick={handleDelete}
                    disabled={!deleteReason.trim()}
                >
                    {Languages[state?.LANGUAGE]?.Delete || "Delete"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteAccountView;
